<template>
    <section class="admin-content" id="contact-search">
        <Navbar />
        <main class="admin-main">
            <section class="">
                <div class="container">
                    <div class="row list">
                        <div class="col-lg-12 col-md-12">
                            <button @click="printMe" class="btn btn-outline-info my-2">
                                Print
                            </button>
                        </div>
                    </div>

                    <div class="row" id="printDiv">

                        <div v-for="(client, index) in clients" :key="client.id" class="print-client-slip">


                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-header">
                                        <div class="row mt-6">
                                            <div class="col-md-12 h3 text-center">
                                                <p class="h5">
                                                    {{index + 1}}

                                                </p>
                                                <strong>
                                                    <h2 class="">
                                                        {{ agency.agency_name }} ({{ agency.firstname }})
                                                    </h2>
                                                </strong>
                                                <strong>
                                                    <p class="text-center">Enrollment Slip</p>
                                                </strong>
                                            </div>

                                            <div class="col-md-12">
                                                <div class="slip-grid">
                                                    <div class="slip-cell" style="grid-column: span 1;">
                                                        <img :src="`${client.image_url}`"
                                                            class="avatar-img avatar-xl rounded"
                                                            onerror="this.onerror=null; this.src='/assets/img/zamfara.jpg'" />
                                                    </div>
                                                    <div class="slip-cell" style="grid-column: span 2;">
                                                        <p class="">
                                                            <b>Generated On: </b>
                                                            <span> {{ current_date }} </span>
                                                        </p>
                                                        <qrcode-vue
                                                            :value="`https://app.claimify.ng/verify-user/${$route.params.id}`"
                                                            :size="50" :level="'H'"
                                                            render-as="svg"></qrcode-vue>
                                                    </div>

                                                    <div class="slip-cell">
                                                        <b>Full Name:</b> {{ client.full_name }}
                                                    </div>
                                                    <div class="slip-cell">
                                                        <b>{{ agency.firstname }} ID:</b>
                                                        {{ client.id_card_number }}
                                                    </div>
                                                    <div class="slip-cell">
                                                        <b>Health Provider:</b>
                                                        <span v-if="client.userprovider != null">
                                                            {{ client.userprovider.agency_name }}
                                                        </span>
                                                    </div>

                                                    <div class="slip-cell">
                                                        <b>Establishment:</b>
                                                        {{ client.place_of_work }}
                                                    </div>
                                                    <div class="slip-cell"><b>Sector: </b> {{ client.sector }}</div>
                                                    <div class="slip-cell">
                                                        <b>Date Enrolled:</b>
                                                        {{
                                                        client.created_at
                                                        | moment("dddd, MMMM Do YYYY")
                                                        }}
                                                    </div>

                                                    <div class="slip-cell"><b>NIN:</b> {{ client.nimc_number }}</div>
                                                    <div class="slip-cell"><b>Gender:</b> {{ client.gender }}</div>
                                                    <div class="slip-cell">
                                                        <b>Phone Number:</b>
                                                        {{ client.phone_number }}
                                                    </div>

                                                    <div class="slip-cell">
                                                        <b>LGA/Ward:</b>
                                                        <span v-if="client.local_government != null">{{
                                                            client.local_government.local_name
                                                            }}</span>
                                                        /

                                                        <span v-if="client.ward != null">
                                                            {{ client.ward.ward_name }}
                                                        </span>
                                                    </div>
                                                    <div class="slip-cell">
                                                        <b>Date of Birth:</b>
                                                        {{ client.dob | moment("D/M/YYYY") }}
                                                    </div>
                                                    <div class="slip-cell"><b>Email:</b>{{ client.email }}</div>

                                                    <div class="slip-cell">
                                                        <b>Expiry Date:</b>
                                                        {{ client.expiry_date }}
                                                    </div>
                                                    <div class="slip-cell">
                                                        <b>Marital Status:</b>
                                                        {{ client.marital_status }}
                                                    </div>
                                                    <div class="slip-cell">
                                                        <b>Employment:</b>
                                                        {{ client.place_of_work }}
                                                    </div>

                                                    <div class="slip-cell">
                                                        <b>Employment ID:</b>
                                                        {{ client.salary_number }}
                                                    </div>
                                                    <div class="slip-cell">
                                                        <b>Vulnrable Group:</b>
                                                        {{ client.category_of_vulnerable_group }}
                                                    </div>
                                                    <div class="slip-cell">
                                                        <b>Address:</b> {{ client.address1 }}
                                                    </div>

                                                    <div class="slip-cell">
                                                        <b>Blood Group:</b> {{ client.blood }}
                                                    </div>
                                                    <div class="slip-cell">
                                                        <b>HMO :</b>
                                                        <span v-if="client.usertpa != null">
                                                            {{ client.usertpa.organization_name }}
                                                        </span>
                                                    </div>
                                                    <div class="slip-cell"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <div class="card m-b-30">
                                    <div class="card-body">
                                        <div class="form-group">
                                            <b class="h5">Enrollee Dependents</b>
                                        </div>

                                        <hr />

                                        <div class="col-md-12 m-b-30">
                                            <div class="table-responsive">
                                                <table class="table align-td-middle table-card">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Avatar</th>
                                                            <th>Name</th>
                                                            <th>ID Number</th>
                                                            <th>DOB</th>
                                                            <th>Gender</th>
                                                            <th>Blood Group</th>
                                                            <th>Relationship</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(dependent, index) in client.dependents"
                                                            v-bind:key="dependent.id">
                                                            <td>
                                                                {{ index + 1 }}
                                                            </td>
                                                            <td>
                                                                <vue-initials-img :name="
                                  dependent.firstname + ' ' + dependent.lastname
                                " class="img-thumbnail" size="25" v-if="dependent.image == null" />

                                                                <div class="avatar avatar-md"
                                                                    v-if="dependent.image != null">
                                                                    <img :src="`${dependent.image_url}`"
                                                                        class="avatar-img avatar-lg rounded"
                                                                        onerror="this.onerror=null; this.src='/assets/img/placeholder.svg'"
                                                                        alt="" />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <router-link
                                                                    :to="{ path: '/provider-' + dependent.id }">
                                                                    <span class="font-bold">
                                                                        {{ dependent.firstname }}
                                                                        {{ dependent.middlename }}
                                                                        {{ dependent.lastname }}
                                                                    </span>
                                                                </router-link>
                                                            </td>
                                                            <td>
                                                                {{ dependent.id_card_number }}
                                                            </td>
                                                            <td>
                                                                {{ dependent.dob }}
                                                            </td>
                                                            <td>{{ dependent.gender }}</td>
                                                            <td>{{ dependent.blood }}</td>
                                                            <td>{{ dependent.relationShipType }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="4">
                                                                <b> Prepared By:</b> {{ user.full_name }}
                                                            </td>

                                                            <td colspan="4" class="text-right">
                                                                <p>
                                                                    <b> Authorized By:</b>
                                                                    .....................................
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <!-- <div class="row col-md-12">
                    <div class="col-md-8">
                      <p><b> Prepared By:</b> {{ user.full_name }}</p>
                    </div>

                    <div class="col-md-4">
                      <p>
                        <b> Authorized By:</b>
                        .....................................
                      </p>
                    </div>
                  </div> -->
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

                <div class="vld-parent">
                    <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage">
                    </loading>
                </div>
            </section>
        </main>
    </section>
</template>

<script>
    import Navbar from "@/views/Navbar.vue";
    // Import component
    import Loading from "vue-loading-overlay";
    // Import stylesheet
    import "vue-loading-overlay/dist/vue-loading.css";
    // Init plugin
    import QRCodeVue from "qrcode.vue";
    let agency = JSON.parse(localStorage.getItem("agency"));
    import moment from "moment";
    moment().format();

    export default {
        components: {
            Navbar,
            Loading,
            qrcodeVue: QRCodeVue,
        },
        data() {
            return {
                agency: agency,
                clients: "",
                current_date: moment().subtract(0, "days").format("YYYY-MM-DD"),
                user: null,
                trx_image: false,
                auth_user: "",
                trx_doc: null,
                notes: "",
                dependents: "",
                enrolled_by: "",
                isLoading: false,
                fullPage: true,

            };
        },
        mounted() {
            this.print();
        },
        beforeMount() {
            this.user = JSON.parse(localStorage.getItem("user"));

        },

        computed: {},

        methods: {
            getUserData() {
                this.isLoading = true;


                this.isLoading = false;

                this.axios
                    .get(`/api/v1/auth/ministry/${this.$route.params.id}`)
                    .then((response) => {
                        this.clients = response.data.enrollees;

                        console.log(response);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },


            async print() {
                const el = this.$refs.printNow;
                const options = {
                    type: "dataURL",
                };
                this.output = await this.$html2canvas(el, options);
            },

            printMe() {
                let printContents = document.getElementById("printDiv").innerHTML;
                let originalContents = document.body.innerHTML;
                document.body.innerHTML = printContents;
                window.print();
                document.body.innerHTML = originalContents;
            },


        },
        created() {
            this.getUserData();
        },
    };
</script>
<style scoped>
    @media print {
        .print-client-slip {
            display: block;
            min-height: 100vh;
            page-break-after: always;
            break-after: page;
            page-break-inside: avoid;
            break-inside: avoid;
        }

        .print-client-slip:last-child {
            page-break-after: auto;
            break-after: auto;
        }
    }
    .slip-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 14px 20px;
        text-align: left;
    }
</style>